import { Outlet } from 'react-router';

import { appRoutes } from '@clearverify/constants';

import { ReactRouteAccessKey } from 'src/constants/reactRouter';
import { EmailTrackerPage } from 'src/pages';
import { RouteProps } from 'src/types/router';

const ROUTES: RouteProps[] = [
  {
    index: true,
    element: <EmailTrackerPage />,
    accessRoles: [ReactRouteAccessKey.hasPlatformRoles],
  },
];

export const EMAIL_TRACKER_ROUTE: RouteProps = {
  path: appRoutes.emailTracker.index,
  element: <Outlet />,
  childRoutes: ROUTES,
  accessRoles: [ReactRouteAccessKey.anyAuthorized],
};
